/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 59a99c5e (Wed Sep  2 22:08:21 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface CreatePlaylistRequestBody
 */
export interface CreatePlaylistRequestBody {
  /**
   * Display name of the playlist.
   * @type string
   * @memberof CreatePlaylistRequestBody
   */
  name: string
  /**
   * Defines the category of the playlist.'LearningCenter' or 'BusinessCenter' content.
   * @type string
   * @memberof CreatePlaylistRequestBody
   */
  playlistType: CreatePlaylistRequestBodyPlaylistTypeEnum
  /**
   * Optional initial asset to include in the playlist. If provided, a corresponding entry will be created in the playlistItem table, otherwise, only the playlist record will be created.
   * @type number
   * @memberof CreatePlaylistRequestBody
   */
  widenAssetKey?: number
}

/**
 * @export
 * @enum {string}
 */
export enum CreatePlaylistRequestBodyPlaylistTypeEnum {
  LearningCenter = 'LearningCenter',
  BusinessCenter = 'BusinessCenter',
}

export function CreatePlaylistRequestBodyFromJSON(
  json: any
): CreatePlaylistRequestBody {
  return CreatePlaylistRequestBodyFromJSONTyped(json, false)
}

export function CreatePlaylistRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreatePlaylistRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: json['name'],
    playlistType: json['playlistType'],
    widenAssetKey: !exists(json, 'widenAssetKey')
      ? undefined
      : json['widenAssetKey'],
  }
}

export function CreatePlaylistRequestBodyToJSON(
  value?: CreatePlaylistRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    playlistType: value.playlistType,
    widenAssetKey: value.widenAssetKey,
  }
}
